import { HFlow, Text } from 'bold-ui'
import { SelectField } from 'components/form/final-form'
import { CboSelectFieldDocument } from 'graphql/hooks.generated'
import { Cbo, CboSelectFieldQuery, CboSelectFieldQueryVariables } from 'graphql/types.generated'
import React from 'react'

import { AsyncSelectFieldProps, DEFAULT_SELECT_PAGE_PARAM, useAsyncQuerySelect } from '../useAsyncQuerySelect'

export type CboSelectModel = Cbo

export interface CboSelectFieldProps extends AsyncSelectFieldProps<CboSelectModel> {
  mostrarIndisponivelLotacao?: boolean
  codigoCboSupervisor?: string
  apenasEquipeCuidadoCompartilhado?: boolean
  equipeVinculadaId?: ID
  nivelSuperior?: boolean
  excludeProfissionaisIds?: ID[]
}

export function CboSelectField(props: CboSelectFieldProps) {
  const {
    codigoCboSupervisor,
    mostrarIndisponivelLotacao,
    apenasEquipeCuidadoCompartilhado,
    equipeVinculadaId,
    nivelSuperior,
    excludeProfissionaisIds,
    ...rest
  } = props

  const { selectProps } = useAsyncQuerySelect<CboSelectModel, CboSelectFieldQuery, CboSelectFieldQueryVariables>({
    query: CboSelectFieldDocument,
    extractItems: (data) => data?.cbos?.content.map((item) => item.cbo),
    variables: (inputQuery) => ({
      input: {
        query: inputQuery,
        mostrarIndisponivelLotacao,
        apenasEquipeCuidadoCompartilhado,
        equipeVinculadaId,
        nivelSuperior,
        cboSupervisor: codigoCboSupervisor,
        excludeProfissionaisIds,
        pageParams: pageParams,
      },
    }),
  })

  const itemToString = (op: CboSelectModel) => op?.nome
  const renderItem = (item: CboSelectModel) => (
    <>
      <Text fontWeight='bold'>{item.nome}</Text>
      <HFlow hSpacing={0.5}>
        <Text fontWeight='bold'>Código:</Text>
        {item.cbo2002}
      </HFlow>
    </>
  )

  return <SelectField<CboSelectModel> itemToString={itemToString} renderItem={renderItem} {...selectProps} {...rest} />
}

const pageParams = {
  ...DEFAULT_SELECT_PAGE_PARAM,
  sort: ['nome'],
}
